import { EntityList } from '@avangard/utils/entity';
import { SchoolProfileItemEntity } from './school-profile-item-entity';

import type { Entity } from './school-profile-item-entity';

class SchoolProfileItemEntityList extends EntityList<SchoolProfileItemEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(SchoolProfileItemEntity, items, count);
    }
}

export { SchoolProfileItemEntityList };
